module.exports = __webpack_public_path__ + "img/19.10.pH.b1190d76.png";